import { useAuth0 } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';
import AppLoadingIndicator from '../common/AppLoadingIndicator';
import GoogleTagManager from 'common/GoogleTagManager';
import EncryptEmail from 'common/EncryptEmail';
import { useEffect, useState } from 'react';
import ErrorPage from 'pages/ErrorPage';

const AuthGuardError = (): JSX.Element => {
  const { user, isLoading, getAccessTokenSilently } = useAuth0();

  const [checkingSession, setCheckingSession] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const checkSession = async () => {
      try {
        // Cast to any if TS complains about ignoreCache
        await getAccessTokenSilently({ ignoreCache: true } as any);

        setAuthenticated(true);
        setError(false);
      } catch {
        setAuthenticated(false);
        setError(true);
      } finally {
        setCheckingSession(false);
      }
    };

    if (!isLoading) {
      checkSession();
    }
  }, [isLoading, getAccessTokenSilently]);

  if (isLoading || checkingSession) {
    return <AppLoadingIndicator />;
  }

  if (authenticated && user) {
    if (user.email) {
      EncryptEmail(user.email).then((result) => {
        GoogleTagManager.sendEmailDuringUserConnection(result);
      });
    }
    return <Outlet />;
  }

  if (error) {
    return <ErrorPage />;
  }

  return <></>;
};

export default AuthGuardError;
